<template>
  <b-card no-body class="border mb-2 h-100">
    <b-card-body class="pb-0">
      <h5 class="mb-0">Endpoints</h5>
      <small class="text-muted">Busiest first</small>
    </b-card-body>

    <b-table
      :items="routes"
      :fields="fields"
      responsive
      show-empty
      empty-text="No calls in this window."
      class="mb-0 usage-routes-table"
    >
      <template #cell(route)="data">
        <b-badge pill :variant="`light-${methodVariant(data.item.method)}`" class="mr-50">
          {{ data.item.method }}
        </b-badge>
        <code class="text-body">{{ data.item.route }}</code>
      </template>

      <template #cell(requests)="data">
        {{ formatCount(data.item.requests) }}
      </template>

      <template #cell(error_rate)="data">
        <b-badge pill :variant="`light-${errorRateVariant(data.item.error_rate)}`">
          {{ formatPercent(data.item.error_rate, 1) }}
        </b-badge>
      </template>

      <template #cell(p95_ms)="data">
        {{ formatDuration(data.item.p95_ms) }}
      </template>

      <template #cell(rows_served)="data">
        {{ formatCount(data.item.rows_served) }}
      </template>

      <template #cell(response_bytes)="data">
        {{ formatBytes(data.item.response_bytes) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable, BBadge } from 'bootstrap-vue'
import {
  errorRateVariant,
  formatBytes,
  formatCount,
  formatDuration,
  formatPercent,
  methodVariant,
} from './usageFormat'

/**
 * Per-endpoint breakdown.
 *
 * Routes arrive as templates (`members/:id`), never as raw URLs — which is what makes
 * them groupable at all, and keeps record ids out of the reporting surface.
 */
export default {
  name: 'UsageRoutesTable',
  components: {
    BCard,
    BCardBody,
    BTable,
    BBadge,
  },
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        { key: 'route', label: 'Endpoint' },
        { key: 'requests', label: 'Calls', class: 'text-right' },
        { key: 'error_rate', label: 'Errors', class: 'text-right' },
        { key: 'p95_ms', label: 'p95', class: 'text-right' },
        { key: 'rows_served', label: 'Records', class: 'text-right' },
        { key: 'response_bytes', label: 'Data', class: 'text-right' },
      ],
    }
  },
  methods: {
    formatCount,
    formatBytes,
    formatPercent,
    formatDuration,
    methodVariant,
    errorRateVariant,
  },
}
</script>

<style scoped>
.usage-routes-table >>> td,
.usage-routes-table >>> th {
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
}
</style>
